// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   SILENCE & GOLD MINIMALIST SIDEBAR & NAVIGATION STYLES
   ============================================================ */

.ddwoms-sidebar {
    position: fixed;
    top: 0;
    left: 0;
    width: 250px;
    height: 100vh;
    height: 100dvh;
    max-height: 100vh;
    box-sizing: border-box;
    background: var(--surface);
    border-right: 1px solid var(--border-subtle);
    display: flex;
    flex-direction: column;
    z-index: 1040;
    overflow: hidden;
    transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1), background 0.18s ease, border-color 0.18s ease;
    box-shadow: none;
}

/* Sidebar collapsed / closed */
.ddwoms-sidebar.is-closed {
    transform: translateX(-250px);
}

/* Scrollable middle navigation */
.ddwoms-nav-scroll {
    flex: 1 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0.5rem 0.75rem 1.5rem;
}
.ddwoms-nav-scroll::-webkit-scrollbar { width: 4px; }
.ddwoms-nav-scroll::-webkit-scrollbar-track { background: transparent; }
.ddwoms-nav-scroll::-webkit-scrollbar-thumb {
    background: var(--border);
    border-radius: 4px;
}
.ddwoms-nav-scroll::-webkit-scrollbar-thumb:hover {
    background: var(--text-faint);
}

/* Main Content Wrapper */
.ddwoms-main {
    flex: 1 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    height: 100vh;
    margin-left: 250px;
    transition: margin-left 0.25s cubic-bezier(0.16, 1, 0.3, 1), background 0.18s ease;
    background: var(--bg);
    overflow: hidden;
}
.ddwoms-main.sidebar-collapsed {
    margin-left: 0;
}

/* Mobile & Tablet Overrides */
@media (max-width: 1023.98px) {
    .ddwoms-main { margin-left: 0; }
    .ddwoms-sidebar {
        transform: translateX(-250px);
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.4), 0 10px 10px -5px rgba(0, 0, 0, 0.3);
    }
    .ddwoms-sidebar.is-open { transform: translateX(0); }
}

/* Backdrop for Mobile */
.ddwoms-sidebar-backdrop {
    position: fixed;
    inset: 0;
    background: var(--color-overlay, rgba(11, 11, 12, 0.75));
    backdrop-filter: blur(4px);
    z-index: 1035;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.25s ease;
}
@media (max-width: 1023.98px) {
    .ddwoms-sidebar-backdrop.is-open {
        opacity: 1;
        pointer-events: auto;
    }
}

/* ── Brand Header ── */
.ddwoms-sidebar-header {
    flex-shrink: 0;
    height: 60px;
    border-bottom: 1px solid var(--border);
    display: flex;
    align-items: center;
    padding: 0 1rem;
    background: var(--surface);
    transition: background 0.18s ease, border-color 0.18s ease;
}

.ddwoms-brand {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    text-decoration: none;
}
.ddwoms-brand-logo-icon {
    width: 34px;
    height: 34px;
    border-radius: 9px;
    background: var(--accent);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--on-accent);
    font-weight: 800;
    font-size: 1rem;
    box-shadow: 0 2px 8px var(--accent-soft);
}
.ddwoms-brand-text {
    font-family: 'Hanken Grotesk', 'Inter', sans-serif;
    font-size: 1.05rem;
    font-weight: 700;
    color: var(--text);
    letter-spacing: -0.02em;
    line-height: 1.2;
}
.ddwoms-brand-tag {
    font-size: 0.65rem;
    font-weight: 600;
    text-transform: uppercase;
    color: var(--accent);
    letter-spacing: 0.06em;
}

/* ── Search Box ── */
.ddwoms-sidebar-search {
    padding: 0.75rem 0.875rem 0.5rem;
}
.search-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
}
.search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 14px;
    height: 14px;
    color: var(--text-faint);
    pointer-events: none;
    z-index: 5;
}
.search-input {
    width: 100% !important;
    height: 38px !important;
    padding-left: 32px !important;
    padding-right: 28px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    font-size: 0.8125rem !important;
    font-weight: 500 !important;
    color: var(--text) !important;
    background: var(--surface-2) !important;
    border: 1px solid var(--border-subtle) !important;
    border-radius: var(--radius-md) !important;
    outline: none !important;
    box-shadow: none !important;
    transition: all 0.15s ease !important;
}
.search-input::placeholder {
    color: var(--text-faint) !important;
    opacity: 1 !important;
}
.search-input:focus {
    background: var(--surface) !important;
    border-color: var(--border-active) !important;
    box-shadow: 0 0 0 3px var(--accent-soft) !important;
}

.search-clear-btn {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    padding: 3px;
    color: var(--text-faint);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
}
.search-clear-btn:hover {
    color: var(--text);
}

/* ── Navigation List ── */
.ddwoms-nav {
    list-style: none;
    margin: 0;
    padding: 0.25rem 0 1rem;
}

.ddwoms-nav-section-title {
    font-family: 'JetBrains Mono', monospace;
    font-size: 0.65rem;
    font-weight: 600;
    text-transform: uppercase;
    color: var(--text-faint);
    padding: 1.25rem 0.5rem 0.35rem;
    letter-spacing: 0.08em;
    -webkit-user-select: none;
            user-select: none;
    line-height: 1;
}
.ddwoms-nav > li:first-child.ddwoms-nav-section-title {
    padding-top: 0.5rem;
}

.ddwoms-nav-item {
    margin: 2px 0;
}

/* ── Nav Links ── */
.ddwoms-nav-link {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.55rem 0.75rem;
    font-size: 0.825rem;
    font-weight: 500;
    color: var(--text-muted);
    text-decoration: none;
    cursor: pointer;
    transition: all 0.15s ease;
    white-space: nowrap;
    border-radius: var(--radius-md);
    position: relative;
    border: 1px solid transparent;
    background: transparent;
    width: 100%;
    text-align: left;
}
.ddwoms-nav-link:hover {
    background: var(--surface-2);
    color: var(--text);
    text-decoration: none;
}

/* ── Active State: full accent border + accent-soft bg ── */
.ddwoms-nav-link.active-link {
    background: var(--accent-soft) !important;
    color: var(--accent) !important;
    border: 1px solid var(--border-active) !important;
    font-weight: 600;
}

.ddwoms-nav-link i {
    width: 18px;
    text-align: center;
    font-size: 0.85rem;
    flex-shrink: 0;
    color: var(--text-muted);
    transition: color 0.15s ease;
}
.ddwoms-nav-link:hover i {
    color: var(--text);
}
.ddwoms-nav-link.active-link i {
    color: var(--accent) !important;
}

.ddwoms-nav-link .nav-arrow {
    margin-left: auto;
    font-size: 0.65rem;
    transition: transform 0.2s;
}
.ddwoms-nav-item.open > .ddwoms-nav-link .nav-arrow {
    transform: rotate(-90deg);
}

/* ── Sticky Sidebar Footer ── */
.ddwoms-sidebar-footer {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0 1rem;
    height: 60px;
    min-height: 60px;
    max-height: 60px;
    box-sizing: border-box;
    background: var(--surface);
    border-top: 1px solid var(--border);
    flex-shrink: 0;
    transition: background 0.18s ease, border-color 0.18s ease;
}

.footer-profile-avatar {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: var(--accent-soft);
    color: var(--accent);
    font-weight: 700;
    font-size: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: 1px solid var(--border);
}

.footer-profile-info {
    flex: 1 1;
    min-width: 0;
}
.footer-profile-name {
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--text);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
}
.footer-profile-role {
    font-size: 0.68rem;
    color: var(--text-muted);
    display: block;
}

.footer-logout-btn {
    background: none;
    border: none;
    color: var(--text-muted);
    cursor: pointer;
    font-size: 0.85rem;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    transition: all 0.15s ease;
}
.footer-logout-btn:hover {
    background: var(--danger-soft);
    color: var(--danger);
}

/* ── Empty Filter Results ── */
.ddwoms-nav-no-results {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 2rem 1rem;
    color: var(--text-muted);
    font-size: 0.75rem;
    text-align: center;
}
.ddwoms-nav-no-results i {
    font-size: 1.25rem;
    opacity: 0.5;
}

/* ── Submenu ── */
.ddwoms-submenu {
    list-style: none;
    margin: 0;
    padding: 0;
    display: none;
}
.ddwoms-nav-item.open > .ddwoms-submenu { display: block; }
.ddwoms-submenu .ddwoms-nav-link {
    padding-left: 2.25rem;
    font-size: 0.78rem;
    font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Partials/Sidebar.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;IAC1B,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,yGAAyG;IACzG,gBAAgB;AACpB;;AAEA,+BAA+B;AAC/B;IACI,6BAA6B;AACjC;;AAEA,iCAAiC;AACjC;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;AAClC;AACA,wCAAwC,UAAU,EAAE;AACpD,8CAA8C,uBAAuB,EAAE;AACvE;IACI,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,6BAA6B;AACjC;;AAEA,yBAAyB;AACzB;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,kFAAkF;IAClF,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;;AAEA,8BAA8B;AAC9B;IACI,eAAe,cAAc,EAAE;IAC/B;QACI,6BAA6B;QAC7B,oFAAoF;IACxF;IACA,0BAA0B,wBAAwB,EAAE;AACxD;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,QAAQ;IACR,wDAAwD;IACxD,0BAA0B;IAC1B,aAAa;IACb,UAAU;IACV,oBAAoB;IACpB,8BAA8B;AAClC;AACA;IACI;QACI,UAAU;QACV,oBAAoB;IACxB;AACJ;;AAEA,uBAAuB;AACvB;IACI,cAAc;IACd,YAAY;IACZ,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,0DAA0D;AAC9D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,wCAAwC;AAC5C;AACA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA,qBAAqB;AACrB;IACI,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,oBAAoB;IACpB,UAAU;AACd;AACA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,yBAAyB;IACzB,4BAA4B;IAC5B,+BAA+B;IAC/B,2BAA2B;IAC3B,6BAA6B;IAC7B,uCAAuC;IACvC,iDAAiD;IACjD,0CAA0C;IAC1C,wBAAwB;IACxB,2BAA2B;IAC3B,qCAAqC;AACzC;AACA;IACI,mCAAmC;IACnC,qBAAqB;AACzB;AACA;IACI,qCAAqC;IACrC,6CAA6C;IAC7C,mDAAmD;AACvD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;;AAEA,0BAA0B;AAC1B;IACI,gBAAgB;IAChB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,yBAAiB;YAAjB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;IACnB,+BAA+B;IAC/B,kBAAkB;IAClB,6BAA6B;IAC7B,uBAAuB;IACvB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,4DAA4D;AAC5D;IACI,yCAAyC;IACzC,+BAA+B;IAC/B,iDAAiD;IACjD,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,wBAAwB;IACxB,4BAA4B;AAChC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,yBAAyB;AAC7B;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,0BAA0B;IAC1B,mCAAmC;IACnC,cAAc;IACd,0DAA0D;AAC9D;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;AACjB;AACA,0CAA0C,cAAc,EAAE;AAC1D;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":["/* ============================================================\n   SILENCE & GOLD MINIMALIST SIDEBAR & NAVIGATION STYLES\n   ============================================================ */\n\n.ddwoms-sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 250px;\n    height: 100vh;\n    height: 100dvh;\n    max-height: 100vh;\n    box-sizing: border-box;\n    background: var(--surface);\n    border-right: 1px solid var(--border-subtle);\n    display: flex;\n    flex-direction: column;\n    z-index: 1040;\n    overflow: hidden;\n    transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1), background 0.18s ease, border-color 0.18s ease;\n    box-shadow: none;\n}\n\n/* Sidebar collapsed / closed */\n.ddwoms-sidebar.is-closed {\n    transform: translateX(-250px);\n}\n\n/* Scrollable middle navigation */\n.ddwoms-nav-scroll {\n    flex: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 0.5rem 0.75rem 1.5rem;\n}\n.ddwoms-nav-scroll::-webkit-scrollbar { width: 4px; }\n.ddwoms-nav-scroll::-webkit-scrollbar-track { background: transparent; }\n.ddwoms-nav-scroll::-webkit-scrollbar-thumb {\n    background: var(--border);\n    border-radius: 4px;\n}\n.ddwoms-nav-scroll::-webkit-scrollbar-thumb:hover {\n    background: var(--text-faint);\n}\n\n/* Main Content Wrapper */\n.ddwoms-main {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    margin-left: 250px;\n    transition: margin-left 0.25s cubic-bezier(0.16, 1, 0.3, 1), background 0.18s ease;\n    background: var(--bg);\n    overflow: hidden;\n}\n.ddwoms-main.sidebar-collapsed {\n    margin-left: 0;\n}\n\n/* Mobile & Tablet Overrides */\n@media (max-width: 1023.98px) {\n    .ddwoms-main { margin-left: 0; }\n    .ddwoms-sidebar {\n        transform: translateX(-250px);\n        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.4), 0 10px 10px -5px rgba(0, 0, 0, 0.3);\n    }\n    .ddwoms-sidebar.is-open { transform: translateX(0); }\n}\n\n/* Backdrop for Mobile */\n.ddwoms-sidebar-backdrop {\n    position: fixed;\n    inset: 0;\n    background: var(--color-overlay, rgba(11, 11, 12, 0.75));\n    backdrop-filter: blur(4px);\n    z-index: 1035;\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 0.25s ease;\n}\n@media (max-width: 1023.98px) {\n    .ddwoms-sidebar-backdrop.is-open {\n        opacity: 1;\n        pointer-events: auto;\n    }\n}\n\n/* ── Brand Header ── */\n.ddwoms-sidebar-header {\n    flex-shrink: 0;\n    height: 60px;\n    border-bottom: 1px solid var(--border);\n    display: flex;\n    align-items: center;\n    padding: 0 1rem;\n    background: var(--surface);\n    transition: background 0.18s ease, border-color 0.18s ease;\n}\n\n.ddwoms-brand {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    text-decoration: none;\n}\n.ddwoms-brand-logo-icon {\n    width: 34px;\n    height: 34px;\n    border-radius: 9px;\n    background: var(--accent);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--on-accent);\n    font-weight: 800;\n    font-size: 1rem;\n    box-shadow: 0 2px 8px var(--accent-soft);\n}\n.ddwoms-brand-text {\n    font-family: 'Hanken Grotesk', 'Inter', sans-serif;\n    font-size: 1.05rem;\n    font-weight: 700;\n    color: var(--text);\n    letter-spacing: -0.02em;\n    line-height: 1.2;\n}\n.ddwoms-brand-tag {\n    font-size: 0.65rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    color: var(--accent);\n    letter-spacing: 0.06em;\n}\n\n/* ── Search Box ── */\n.ddwoms-sidebar-search {\n    padding: 0.75rem 0.875rem 0.5rem;\n}\n.search-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n    width: 100%;\n}\n.search-icon {\n    position: absolute;\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 14px;\n    height: 14px;\n    color: var(--text-faint);\n    pointer-events: none;\n    z-index: 5;\n}\n.search-input {\n    width: 100% !important;\n    height: 38px !important;\n    padding-left: 32px !important;\n    padding-right: 28px !important;\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    font-size: 0.8125rem !important;\n    font-weight: 500 !important;\n    color: var(--text) !important;\n    background: var(--surface-2) !important;\n    border: 1px solid var(--border-subtle) !important;\n    border-radius: var(--radius-md) !important;\n    outline: none !important;\n    box-shadow: none !important;\n    transition: all 0.15s ease !important;\n}\n.search-input::placeholder {\n    color: var(--text-faint) !important;\n    opacity: 1 !important;\n}\n.search-input:focus {\n    background: var(--surface) !important;\n    border-color: var(--border-active) !important;\n    box-shadow: 0 0 0 3px var(--accent-soft) !important;\n}\n\n.search-clear-btn {\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    padding: 3px;\n    color: var(--text-faint);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n}\n.search-clear-btn:hover {\n    color: var(--text);\n}\n\n/* ── Navigation List ── */\n.ddwoms-nav {\n    list-style: none;\n    margin: 0;\n    padding: 0.25rem 0 1rem;\n}\n\n.ddwoms-nav-section-title {\n    font-family: 'JetBrains Mono', monospace;\n    font-size: 0.65rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    color: var(--text-faint);\n    padding: 1.25rem 0.5rem 0.35rem;\n    letter-spacing: 0.08em;\n    user-select: none;\n    line-height: 1;\n}\n.ddwoms-nav > li:first-child.ddwoms-nav-section-title {\n    padding-top: 0.5rem;\n}\n\n.ddwoms-nav-item {\n    margin: 2px 0;\n}\n\n/* ── Nav Links ── */\n.ddwoms-nav-link {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.55rem 0.75rem;\n    font-size: 0.825rem;\n    font-weight: 500;\n    color: var(--text-muted);\n    text-decoration: none;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    white-space: nowrap;\n    border-radius: var(--radius-md);\n    position: relative;\n    border: 1px solid transparent;\n    background: transparent;\n    width: 100%;\n    text-align: left;\n}\n.ddwoms-nav-link:hover {\n    background: var(--surface-2);\n    color: var(--text);\n    text-decoration: none;\n}\n\n/* ── Active State: full accent border + accent-soft bg ── */\n.ddwoms-nav-link.active-link {\n    background: var(--accent-soft) !important;\n    color: var(--accent) !important;\n    border: 1px solid var(--border-active) !important;\n    font-weight: 600;\n}\n\n.ddwoms-nav-link i {\n    width: 18px;\n    text-align: center;\n    font-size: 0.85rem;\n    flex-shrink: 0;\n    color: var(--text-muted);\n    transition: color 0.15s ease;\n}\n.ddwoms-nav-link:hover i {\n    color: var(--text);\n}\n.ddwoms-nav-link.active-link i {\n    color: var(--accent) !important;\n}\n\n.ddwoms-nav-link .nav-arrow {\n    margin-left: auto;\n    font-size: 0.65rem;\n    transition: transform 0.2s;\n}\n.ddwoms-nav-item.open > .ddwoms-nav-link .nav-arrow {\n    transform: rotate(-90deg);\n}\n\n/* ── Sticky Sidebar Footer ── */\n.ddwoms-sidebar-footer {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0 1rem;\n    height: 60px;\n    min-height: 60px;\n    max-height: 60px;\n    box-sizing: border-box;\n    background: var(--surface);\n    border-top: 1px solid var(--border);\n    flex-shrink: 0;\n    transition: background 0.18s ease, border-color 0.18s ease;\n}\n\n.footer-profile-avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    background: var(--accent-soft);\n    color: var(--accent);\n    font-weight: 700;\n    font-size: 0.75rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    border: 1px solid var(--border);\n}\n\n.footer-profile-info {\n    flex: 1;\n    min-width: 0;\n}\n.footer-profile-name {\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: var(--text);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: block;\n}\n.footer-profile-role {\n    font-size: 0.68rem;\n    color: var(--text-muted);\n    display: block;\n}\n\n.footer-logout-btn {\n    background: none;\n    border: none;\n    color: var(--text-muted);\n    cursor: pointer;\n    font-size: 0.85rem;\n    padding: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 6px;\n    transition: all 0.15s ease;\n}\n.footer-logout-btn:hover {\n    background: var(--danger-soft);\n    color: var(--danger);\n}\n\n/* ── Empty Filter Results ── */\n.ddwoms-nav-no-results {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    padding: 2rem 1rem;\n    color: var(--text-muted);\n    font-size: 0.75rem;\n    text-align: center;\n}\n.ddwoms-nav-no-results i {\n    font-size: 1.25rem;\n    opacity: 0.5;\n}\n\n/* ── Submenu ── */\n.ddwoms-submenu {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: none;\n}\n.ddwoms-nav-item.open > .ddwoms-submenu { display: block; }\n.ddwoms-submenu .ddwoms-nav-link {\n    padding-left: 2.25rem;\n    font-size: 0.78rem;\n    font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
